<template>
  <div class="section-title-card" :class="{ reversed }">
    <PopupText :text="text" tag="h2" :delay="0" :active="active" />
    <div>
      <div class="shape-top">
        <div>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <mask :id="maskId">
              <polygon
                vector-effect="non-scaling-stroke"
                stroke="white"
                stroke-width="60px"
                stroke-linejoin="round"
                :points="points"
                fill="white"
              />
            </mask>
            <defs>
              <linearGradient :id="gradientId">
                <stop class="stop1" offset="0%" />
                <stop class="stop2" offset="100%" />
              </linearGradient>
              <linearGradient :id="gradientBId">
                <stop class="stop1" offset="0%" />
                <stop class="stop2" offset="100%" />
              </linearGradient>
            </defs>
            <rect
              :mask="`url(#${maskId})`"
              x="0"
              y="0"
              width="100"
              height="100"
              rx="0"
              ry="0"
              :fill="`url(#${gradientId})`"
            />
          </svg>
        </div>
      </div>
      <div class="shape-bottom">
        <div>
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <rect
              :mask="`url(#${maskId})`"
              x="0"
              y="0"
              width="100"
              height="100"
              rx="0"
              ry="0"
              :fill="`url(#${gradientBId})`"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
class SectionTitleCard extends Vue {
  @Prop({ type: String, default: 'Some Text!' }) text;
  @Prop({ type: Boolean, default: true }) active;
  @Prop({ type: String, default: '#ed2024' }) colorA;
  @Prop({ type: String, default: '#ed1f79' }) colorB;
  @Prop({ type: String, default: '#800100' }) colorC;
  @Prop({ type: String, default: '#cb277a' }) colorD;

  get gradientId() {
    return `title-card-gradient-${this._uid}`;
  }

  get gradientBId() {
    return `title-card-gradient-b-${this._uid}`;
  }

  get maskId() {
    return `title-card-mask-${this._uid}`;
  }

  get reversed() {
    return this.$attrs.hasOwnProperty('reversed');
  }

  get points() {
    // return this.reversed
    //   ? '0 25, 100 0, 95 100, 5 75'
    //   : '0 0, 100 25, 95 75, 5 100';
    return this.reversed
      ? '10 45, 90 20, 85 80, 13 65'
      : '10 20, 90 35, 85 65, 13 80';
  }

  mounted() {
    $(this.$el).append(`
      <style>
        #${this.gradientId} > .stop1 {
          stop-color: ${this.colorA};
        }

        #${this.gradientId} > .stop2 {
          stop-color: ${this.colorB};
        }

        #${this.gradientBId} > .stop1 {
          stop-color: ${this.colorC};
        }

        #${this.gradientBId} > .stop2 {
          stop-color: ${this.colorD};
        }
      </style>
    `);
  }
}

export default SectionTitleCard;
</script>

<style lang="scss" scoped>
.section-title-card {
  display: inline-flex;
  position: relative;
  // max-width: 60vw;
  padding: 40px 0;
  margin-left: 30px;
  width: 100%;
  min-height: 200px;
  max-width: 400px;
  text-align: center;
  align-items: center;
  justify-content: center;

  > h2 {
    margin: 0;
    color: white;
    position: relative;
    display: inline-block;

    > span {
      text-shadow: -5px 6px 0px rgba(0, 0, 0, 0.15);
      position: relative;
      z-index: 1;
    }
  }

  > div {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    > div {
      position: absolute;
      top: -50px;
      right: -70px;
      left: -70px;
      bottom: -40px;
      margin: 0 auto;
      filter: drop-shadow(0 10px 10px rgba(0, 0, 0, 0.25));
      z-index: 0;

      > div {
        width: 100%;
        height: 100%;

        > svg {
          width: 100%;
          height: 100%;
        }
      }

      &.shape-top {
        z-index: 1;
      }

      &.shape-bottom {
        > div {
          transform: translateX(-30px) translateY(30px) rotateZ(-5deg);
        }
      }
    }
  }

  &.reversed {
    margin-left: -30px;
    > div {
      > div {
        &.shape-bottom {
          > div {
            transform: translateX(30px) translateY(30px) rotateZ(5deg);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SectionTitleCard.vue